import React, { Component } from 'react';
import { BrowserRouter, Route, Switch, Redirect } from 'react-router-dom';

import Header from './Header';
import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import Step5 from './Step5';
import Step6 from './Step6';
import Navbar from './Navbar';
import ScrollToTop from './ScrollToTop';
import AutomaticRouter from './AutomaticRouter';

class Routes extends Component {
	render() {
		return (
			<BrowserRouter basename="/booking-form/v2">
				<div>
					<ScrollToTop/>
					<Header />
					<Switch>
						<Route exact path={RoutePathname.STEP1} component={Step1} />
						<Route exact path={RoutePathname.STEP2} component={Step2} />
						<Route exact path={RoutePathname.STEP3} component={Step3} />
						<Route exact path={RoutePathname.STEP4} component={Step4} />
						<Route exact path={RoutePathname.STEP5} component={Step5} />
						<Route exact path={RoutePathname.STEP6} component={Step6} />
						<Redirect to={RoutePathname.STEP1} />
					</Switch>
					<Navbar
						recaptcha={this.props.recaptcha}
						recaptchaToken={this.props.recaptchaToken}
					/>
					<AutomaticRouter />
				</div>
			</BrowserRouter>
		);
	}
}

export const RoutePathname = {
	STEP1: '/',
	STEP2: '/2',
	STEP3: '/3',
	STEP4: '/4',
	STEP5: '/5',
	STEP6: '/6',
};

export default Routes;



// WEBPACK FOOTER //
// ./src/components/Routes.jsx